import { httpClient } from './http-client';
import type { ApiResponse, PaginatedResponse } from './api.types';
import type {
  CreateRetroalimentacionDTO,
  EstadoRetroalimentacionMensual,
  FiltroResultadosRetroalimentacion,
  Retroalimentacion,
  RetroalimentacionDetalle,
  ResumenRetroalimentacion,
} from '../../modelos/Retroalimentacion';

const construirParametros = (
  filtro: FiltroResultadosRetroalimentacion,
  extra: Record<string, string | number | undefined> = {},
): Record<string, string | number | boolean | undefined> => ({
  desde: filtro.desde,
  hasta: filtro.hasta,
  empresaId: filtro.empresaId,
  modulo: filtro.modulo,
  tipo: filtro.tipo,
  busqueda: filtro.busqueda?.trim() || undefined,
  ...extra,
});

export const retroalimentacionesService = {
  getEstadoMensual: (): Promise<ApiResponse<EstadoRetroalimentacionMensual>> => {
    return httpClient.get('/retroalimentaciones/estado-mensual');
  },

  getResumen: (filtro: FiltroResultadosRetroalimentacion): Promise<ApiResponse<ResumenRetroalimentacion>> => {
    return httpClient.get('/retroalimentaciones/resumen', construirParametros(filtro));
  },

  getDetalle: (
    filtro: FiltroResultadosRetroalimentacion,
    paginacion: { page: number; pageSize: number },
  ): Promise<ApiResponse<RetroalimentacionDetalle[]>> => {
    return httpClient.get('/retroalimentaciones/detalle', construirParametros(filtro, paginacion));
  },

  descargarExcel: (filtro: FiltroResultadosRetroalimentacion): Promise<Blob> => {
    return httpClient.obtenerBlob('/retroalimentaciones/exportar/excel', construirParametros(filtro));
  },

  getAll: (params?: {
    page?: number;
    pageSize?: number;
    tipo?: string;
  }): Promise<ApiResponse<PaginatedResponse<Retroalimentacion>>> => {
    return httpClient.get('/retroalimentaciones', params);
  },

  getById: (id: string): Promise<ApiResponse<Retroalimentacion>> => {
    return httpClient.get(`/retroalimentaciones/${id}`);
  },

  create: (data: CreateRetroalimentacionDTO): Promise<ApiResponse<Retroalimentacion>> => {
    return httpClient.post('/retroalimentaciones', data);
  },

  delete: (id: string): Promise<ApiResponse<void>> => {
    return httpClient.delete(`/retroalimentaciones/${id}`);
  },
};
